import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'payaStatus'
})
export class PayaStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      switch (value) {
        case 'CANCEL': {
          return 'کنسل شده';
          break;
        }
        case 'PROCESSED': {
          return 'انجام شده';
          break;
        }
        case 'WAIT_FOR_CUSTOMER_ACCEPT': {
          return 'در انتظار تایید مشتری';
          break;
        }
        case 'WAIT_FOR_BRANCH_ACCEPT' : {
          return 'در انتظار تایید شعبه';
          break;
        }
        case 'BRANCH_REJECT' : {
          return 'رد شده در شعبه';
          break;
        }
        case 'READY_TO_TRANSFER' : {
          return 'آماده انتقال';
          break;
        }
        case 'SUSPEND': {
          return 'مسدود شده';
          break;
        }
        default: {
          return value;
          break;
        }
      }
    }
  }

}
